import {
    IMappingTextPack,
    MappingTextPack
} from "esdm-map";

export class TextPacks {
    public constructor(       
        public mapping: IMappingTextPack
    ) { }
}

export class TextPackLoader {

    public static load(): Promise<TextPacks> {       
        let mapping = MappingTextPack.load();

        return Promise.all([mapping]).then(
            function (results) {
                return new TextPacks(results[0]);
            }
        )
    }
}